import { hot } from 'react-hot-loader/root';
import Component from './simpleSharing-redux';

export default hot(Component);
